import { createFileRoute } from '@tanstack/react-router';
import { PersonalSecurityNewTotpRoute } from './-route-wrappers';

// Underscored path segment, matching the URL Ember has always served.
export const Route = createFileRoute('/_authenticated/settings/personal/security/new_totp')({
  component: PersonalSecurityNewTotpRoute,
});
